import React from 'react';
import LimitTableFilter from '../../../components/limit/LimitTableFilter';

function PriceAnalysisLimitBox({ isRegion }: { isRegion?: boolean }) {
  return (
    <LimitTableFilter title="가격분석은" isRegion={isRegion}>
      <div />
    </LimitTableFilter>
  );
}

export default PriceAnalysisLimitBox;
